const ACCENTS = {
  'Today':        'var(--series-7)',
  'This Month':   'var(--series-3)',
  'Last Month':   'var(--series-2)',
  'Custom Range': 'var(--series-1)',
};

const ICONS = {
  'Today': () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 16 14" />
    </svg>
  ),
  'This Month': () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  'Last Month': () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 12a9 9 0 1 0 3-7" />
      <polyline points="3 4 3 9 8 9" />
    </svg>
  ),
  'Custom Range': () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
  ),
};

const fmtUSD = (n) =>
  '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const fmtN = (n) => Number(n || 0).toLocaleString('en-US');

const fmtLocal = (n, code) => {
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency', currency: code, maximumFractionDigits: 2,
    }).format(n);
  } catch { return null; }
};

export default function CommissionCard({
  title,
  variant,
  value = 0,
  trend,
  transactions = 0,
  clients = 0,
  loading = false,
  localRate,
  localCode,
}) {
  const accentKey = variant === 'day' ? 'Today' : variant === 'currentMonth' ? 'This Month' : variant === 'previousMonth' ? 'Last Month' : title;
  const accent = ACCENTS[accentKey] || ACCENTS['Last Month'];
  const Icon = ICONS[accentKey] || ICONS['Last Month'];
  const trendNum = trend !== null && trend !== undefined ? Number(trend) : null;
  const count = clients > 0
    ? `${fmtN(clients)} clients`
    : transactions > 0
    ? `${fmtN(transactions)} contracts`
    : null;
  const localAmount = localRate && localCode && value > 0 ? value * localRate : null;
  const localStr = localAmount ? fmtLocal(localAmount, localCode) : null;

  if (loading) {
    return (
      <div className="stat-card stat-card--loading" aria-busy="true">
        <div className="stat-card-body">
          <div className="skel skel-label" style={{ width: '45%', height: 12 }} />
          <div className="skel skel-value" style={{ marginTop: 9, height: 27, width: '70%' }} />
          <div className="skel skel-meta" style={{ marginTop: 8, height: 10, width: '55%' }} />
        </div>
      </div>
    );
  }

  return (
    <div
      className="stat-card"
      style={{ '--ac': accent }}
    >
      <div className="stat-card-body">
        <div className="stat-card-main">
          <div className="stat-card-row">
            <span className="stat-label">
              <span className="stat-card-icon"><Icon /></span>
              {title}
            </span>
            <span className="stat-row-end">
              {trendNum !== null && (
                <span className={`stat-trend ${trendNum >= 0 ? 'up' : 'down'}`}>
                  {trendNum >= 0 ? '+' : ''}{trendNum}%
                </span>
              )}
              {count && <span className="stat-count">{count}</span>}
            </span>
          </div>
          <div className="stat-card-row stat-card-row--value">
            <span className="stat-value">{fmtUSD(value)}</span>
            {localStr && <span className="stat-local">{localStr}</span>}
          </div>
        </div>
      </div>
    </div>
  );
}
